import {ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { interval, take } from 'rxjs';

@Component({
  selector: 'app-error',
  imports: [RouterLink],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent implements OnInit {
  readonly redirectDelay = 10;
  readonly secondsRemaining = signal(this.redirectDelay);
  readonly secondsRemainingText = computed(() => {
    if (this.secondsRemaining() === 1) {
      return `${this.secondsRemaining()} second`;
    }

    return `${this.secondsRemaining()} seconds`
  });

  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    interval(1000)
      .pipe(take(this.redirectDelay), takeUntilDestroyed(this.destroyRef))
      .subscribe((elapsed) => {
        const remaining = this.redirectDelay - elapsed - 1;
        this.secondsRemaining.set(remaining);

        if (remaining === 0) {
          void this.router.navigateByUrl('/', { replaceUrl: true });
        }
      });
  }
}
